module.exports = __webpack_public_path__ + "img/luxury_apply@2x.69ccb9cf.png";